export default "__VITE_ASSET__BAXXy3lT__"